import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

interface ImportDetailsResponse {
    id: number;
    type: string;
    import_errors: Record<string, string>;
}

export const useErrorImport = (id: number | null) => {
    const queryFn = async () => {
        const { data } = await api.get<ImportDetailsResponse>(
            `import-request/${id}`,
        );

        return data;
    };

    return useQuery({
        queryFn,
        queryKey: ['IMPORT_REQUEST_INFO', id],
        enabled: !!id,
    });
};
